// extracted by mini-css-extract-plugin
module.exports = {"reviewtabMinWidth":"415px","btn_manage":"N0VK7o","icon":"bHK4fh","btn":"yLc_5A","AniFadeIn":"ZON7ji","AniFadeOut":"nx1VxH","AniRotate":"LP4bk3","AniPlaceholderFadeOut":"ly7JcV"};